//---------------------------------------------------------
// Soft #40: dashboard charts served by the OAM PromQL proxy.
// The browser only names a chart. It never sends or receives PromQL and
// never learns the Prometheus address.
//---------------------------------------------------------
export const METRICS_CHART_NAMES = ['total-requests', 'backend-balance', 'traffic-distribution', 'top-clients'] as const;

export type MetricsChartName = (typeof METRICS_CHART_NAMES)[number];

export interface IMetricsChartSample {
	labels: Record<string, string>;
	value: number;
}

export interface IMetricsChartSeries {
	key: string;
	samples: IMetricsChartSample[];
	truncated?: boolean;
}

export interface IMetricsChartResult {
	name: MetricsChartName;
	title: string;
	series: IMetricsChartSeries[];
	queriedAt: string;
}

// Server error codes (OAM soft_metrics_charts_handler.go).
export type MetricsChartErrorCode = 'METRICS_NOT_CONFIGURED' | 'METRICS_UNAVAILABLE' | 'METRICS_BAD_RESPONSE' | 'BACKENDS_UNAVAILABLE' | 'INSTANCE_LOOKUP_UNAVAILABLE' | 'NOT_FOUND' | 'UNKNOWN';

export class MetricsChartError extends Error {
	status: number;
	code: MetricsChartErrorCode;
	constructor(status: number, code: MetricsChartErrorCode, message: string) {
		super(message);
		this.name = 'MetricsChartError';
		this.status = status;
		this.code = code;
	}
}
